import axios from "axios";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { FaRegCheckCircle as Check } from "react-icons/fa";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Complete from "../../assets/svgs/Complete.svg";
import high from "../../assets/svgs/high.svg";
import low from "../../assets/svgs/low.svg";
import medium from "../../assets/svgs/medium.svg";
import none from "../../assets/svgs/None.svg";
import Plus from "../../assets/svgs/Plus.svg";
import sortAsce from "../../assets/svgs/sort-ascending.svg";
import sortDesc from "../../assets/svgs/sort-descending.svg";
import swap from "../../assets/svgs/swap-vertical.svg";
import ColumnCustomizer from "../../components/ColumnCustomizer";
import ArchiveConfirmationModal from "../../components/ConfirmationModals/ArchiveConfirmationModal";
import DeleteConfirmationModal from "../../components/ConfirmationModals/DeleteConfirmationModal";
import UnarchiveConfirmationModal from "../../components/ConfirmationModals/UnarchieveConfirmationModal";
import AddNoteModal from "../../components/DetailTabsData/Modals/AddNoteModal";
import CompleteTaskModal from "../../components/DetailTabsData/Modals/CompleteTaskModal";
import ResheduleTaskModal from "../../components/DetailTabsData/Modals/ResheduleTaskModal";
import TaskFilter from "../../components/FilterComponents/TaskFilter";
import Loader from "../../components/Loader";
import TaskPagination from "../../components/Pagination/TaskPagination";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import { initialTaskFilterData } from "../../utils/initialData";
import TaskActionMenu from "./components/TaskActionMenu";
import AddtaskModal from "./modals/AddTaskModal";
import EditTaskModal from "./modals/EditTaskModal";
import TaskDetailsModal from "./TaskDetailsModal";
import "./Tasks.css";

const archiveMenuOption = ["Unarchive", "Delete"];
const todoMenuOption = ["Edit", "Reschedule", "Archive"];

const Tasks = () => {
  const userType = useSelector((state) => state.userType);
  const isSidebarCollapsed = useSelector((state) => state.isSidebarCollapsed);
  const [config] = useAuth();
  const navigate = useNavigate();

  const [date, setDate] = useState();
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [taskData, setTaskData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(50);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showColumnModal, setShowColumnModal] = useState(false); // ← New State
  const [taskType, setTaskType] = useState("myTask");
  const [sortBy, setSortBy] = useState("due_date");
  const [sortDirection, setSortDirection] = useState("asc");
  const [selectedItem, setSelectedItem] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [disableDelete, setDisableDelete] = useState(false);
  const [showCtaskModal, setShowCtaskModal] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showEditTaskModal, setShowEditTaskModal] = useState(false);
  const [showUnarchiveModal, setShowUnarchiveModal] = useState(false);
  const [showCompleteTaskModal, setShowCompleteTaskModal] = useState(false);
  const [showResheduleTaskModal, setShowResheduleTaskModal] = useState(false);
  const [paginationData, setPaginationData] = useState({
    totalItems: 0,
    from: 0,
    to: 0,
    totalPages: 0,
  });
  const [filterData, setFilterData] = useState(() => {
    const localFilterData = localStorage.getItem("filterData");
    return localFilterData ? JSON.parse(localFilterData) : initialTaskFilterData;
  });

  // ==================== COLUMN CUSTOMIZATION ====================
  const allColumns = [
    { key: 'select', label: 'Select', fixed: true },
    { key: 'task_name', label: 'Task Name', fixed: true },
    { key: 'linked_to', label: 'Linked To' },
    { key: 'assigned_to', label: 'Assigned To' },
    { key: 'priority', label: 'Priority' },
    { key: 'due_date', label: 'Due Date' },
    { key: 'created_by', label: 'Created By' },
    { key: 'more', label: 'More', fixed: true },
  ];

  const [visibleColumns, setVisibleColumns] = useState(() => {
    const saved = localStorage.getItem('taskVisibleColumns');
    return saved
      ? JSON.parse(saved)
      : allColumns.map(col => col.key); // Show all by default
  });
  // ============================================================

  const debounceTimeout = useRef(null);

  const taskIds = taskData.map((el) => el.id);

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    const trimmed = value.startsWith(" ") ? value.trimStart() : value;
    setSearch(trimmed);
  };

  // Debounce search
  useEffect(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      // Only update debounced value if search is empty or >= 3 characters
      if (search.length === 0 || search.length >= 3) {
        setDebouncedSearch(search.trim());
      }
    }, 450);

    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [search]);

  const buildQueryParams = (filters) => {
    let params = `status=${activeTab}&page=${pageNumber}&per_page=${itemPerPage}&type=${taskType === "teamTask" ? "team_task" : "my_task"
      }&search=${encodeURIComponent(debouncedSearch)}`;

    const {
      selectedPriorities,
      selectedTaskTypes,
      start_date,
      end_date,
      selectedLinkedOptions,
      isRepeatingTask,
      selectedDueDate,
      CreatedBy,
    } = filters;

    if (selectedPriorities?.length > 0) {
      params += `&priority=${selectedPriorities.join(",")}`;
    }

    if (selectedTaskTypes?.length > 0) {
      params += `&task_type=${selectedTaskTypes.join(",")}`;
    }

    if (selectedLinkedOptions?.length > 0) {
      params += `&linked_to=${selectedLinkedOptions.join(",")}`;
    }

    if (isRepeatingTask !== "no") {
      params += `&repeating_tasks=${isRepeatingTask}`;
    }

    if (selectedDueDate) {
      params += `&due_date=${selectedDueDate}`;
    }
    if (start_date) {
      params += `&start_date=${start_date}`;
    }
    if (end_date) {
      params += `&end_date=${end_date}`;
    }
    if (CreatedBy) {
      params += `&created_by=${CreatedBy}`;
    }

    if (sortDirection && sortBy !== "id") {
      params += `&sort_direction=${sortDirection}`;
    }

    if (sortBy !== "id") {
      params += `&sort_column=${sortBy}`;
    }

    return params;
  };

  const fetchTasks = (filters) => {
    const queryParams = buildQueryParams(filters);
    setIsLoading(true);

    axios
      .get(`${BASE_URL}/task-list?${queryParams}`, config)
      .then((res) => {
        const value = res?.data?.tasks;
        setTaskData(
          value?.data.map((task) => ({
            ...task,
            smartplan_id: task.smartplan_id,
          }))
        );
        setPaginationData({
          totalItems: value?.total ?? 0,
          from: value?.from ?? 0,
          to: value?.to ?? 0,
          totalPages: value?.last_page ?? 0,
        });
        setSelectedItem([]);
        setIsSelectAll(false);
      })
      .catch((err) => {
        setTaskData([]);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onSuccess = (filters = filterData) => {
    fetchTasks(filters);
  };

  // Fetch when these change
  useEffect(() => {
    onSuccess();
  }, [activeTab, pageNumber, debouncedSearch, taskType, itemPerPage, sortBy, sortDirection]);

  // Reset page when filters or tabs change
  useEffect(() => {
    setPageNumber(1);
  }, [activeTab, debouncedSearch, taskType]);

  const handleSelectCheck = (id) => {
    if (selectedItem.includes(id)) {
      setSelectedItem(selectedItem.filter((el) => el !== id));
    } else {
      setSelectedItem([...selectedItem, id]);
    }
  };

  useEffect(() => {
    setIsSelectAll(selectedItem.length === taskIds.length && taskIds.length > 0);
  }, [selectedItem, taskIds]);

  const handleTaskClick = (task) => {
    setSelectedTask(task);
    setShowModal(true);
  };

  const handleArchieve = () => {
    axios
      .post(`${BASE_URL}/perform-Action?action=archive&task_id=${selectedTask?.id}`, {}, config)
      .then((res) => {
        onSuccess();
        setShowArchiveModal(false);
        NotificationManager.success(res?.data?.message || "Task archived");
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleUnarchieve = () => {
    axios
      .post(`${BASE_URL}/perform-Action?action=unarchive&task_id=${selectedTask?.id}`, {}, config)
      .then((res) => {
        onSuccess();
        setShowUnarchiveModal(false);
        NotificationManager.success(res?.data?.message || "Task unarchived");
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleDelete = () => {
    setDisableDelete(true);
    axios
      .post(`${BASE_URL}/perform-Action?action=delete&task_id=${selectedTask?.id}`, {}, config)
      .then((res) => {
        onSuccess();
        setShowDeleteModal(false);
        NotificationManager.success(res?.data?.message || "Task deleted");
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setDisableDelete(false));
  };

  const handleResheduleTask = () => {
    axios
      .post(`${BASE_URL}/perform-Action?action=reschedule&task_id=${selectedTask?.id}`, { due_date: date }, config)
      .then((res) => {
        onSuccess();
        setShowResheduleTaskModal(false);
        NotificationManager.success(res?.data?.message || "Task rescheduled");
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleNext = () => {
    if (pageNumber < paginationData.totalPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const handlePrev = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const getDueDateInfo = (dueDate) => {
    const now = moment().tz("America/New_York").startOf("day");
    const due = moment(dueDate).tz("America/New_York").startOf("day");
    const daysDiff = due.diff(now, "days");

    if (daysDiff < 0) return { className: "red-D red-bg-L", label: "Past Due" };
    if (daysDiff === 0) return { className: "orange-D orange-bg-L", label: "Due Today" };
    if (daysDiff <= 7) return { className: "green-D green-bg", label: "Due Next 7 Days" };
    return { className: "puple_D puple-bg-L dark-M", label: "Due Later" };
  };

  return (
    <BaseLayout>
      <div className="contact-header">
        <p className="head-1 dark-H">
          Tasks
          {selectedItem.length > 0 && (
            <span className="body-L ml-2">
              ({selectedItem.length} <span className="dark-H">{selectedItem.length === 1 ? "item" : "items"} selected</span>)
            </span>
          )}
        </p>
        <div className="flex gap-4 items-center">
          <TaskFilter
            filterData={filterData}
            onSetFilterData={setFilterData}
            onCallApiAgain={onSuccess}
          />

          <div className="search-box contacts">
            <input
              type="text"
              className="body-S"
              placeholder="Search Task Name"
              value={search}
              onChange={handleSearchChange}
              style={{ border: "1px solid #D8D8D8", marginTop: "0px" }}
            />
          </div>

          {/* New Customize Columns Button */}
          <button
            className="add-contact-button green-bg-H light-L body-S flex items-center gap-1"
            onClick={() => setShowColumnModal(true)}
          >
            Columns ⚙️
          </button>

          <button
            className="add-contact-button green-bg-H light-L body-S"
            onClick={() => setShowCtaskModal(true)}
          >
            <img className="mr-2 sidebar-icons" src={Plus} alt="plus" /> Create
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="task-tabs mx-1 mt-2 flex justify-between body-L dark-M">
        <div className="flex gap-4">
          <p
            role="button"
            className={`${activeTab === 0 ? "head-4 dark-H active" : ""} pb-3`}
            onClick={() => {
              setActiveTab(0);
              setPageNumber(1);
            }}
          >
            To Do
          </p>
          <p
            role="button"
            className={`${activeTab === 1 ? "head-4 dark-H active" : ""} pb-3`}
            onClick={() => {
              setActiveTab(1);
              setPageNumber(1);
            }}
          >
            Completed
          </p>
          <p
            role="button"
            className={`${activeTab === 2 ? "head-4 dark-H active" : ""} pb-3`}
            onClick={() => {
              setActiveTab(2);
              setPageNumber(1);
            }}
          >
            Archived
          </p>
        </div>

        {userType !== 3 && (
          <div className="flex gap-4">
            <p
              role="button"
              className={`${taskType === "myTask" ? "head-4 dark-H active" : ""} pb-3`}
              onClick={() => {
                setTaskType("myTask");
                setPageNumber(1);
              }}
            >
              My Tasks
            </p>
            <p
              role="button"
              className={`${taskType === "teamTask" ? "head-4 dark-H active" : ""} pb-3`}
              onClick={() => {
                setTaskType("teamTask");
                setPageNumber(1);
              }}
            >
              Team Tasks
            </p>
          </div>
        )}
      </div>

      <div className="light-bg-L pb-3 table-container" style={{ marginTop: "0px" }}>
        <div className={`${isSidebarCollapsed ? "collapsed-width" : "width"} table-info light-bg-L`}>
          {isLoading ? (
            <Loader />
          ) : taskData.length === 0 ? (
            <p className="body-N text-center mt-6 p-10">No Tasks Available</p>
          ) : (
            <table className="contact-table two-rows-static light-bg-L">
              <thead>
                <tr className="uppercase body-N dark-M">
                  {visibleColumns.includes('select') && (
                    <th>
                      <label className="container">
                        <input
                          type="checkbox"
                          checked={isSelectAll}
                          onChange={(e) => {
                            setIsSelectAll(e.target.checked);
                            setSelectedItem(e.target.checked ? taskIds : []);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </th>
                  )}
                  {visibleColumns.includes('task_name') && (
                    <th className="green-H">
                      <div className="table-header">
                        Task Name
                        <img
                          role="button"
                          src={sortBy !== "task_name" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("task_name");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="sort"
                        />
                      </div>
                    </th>
                  )}
                  {visibleColumns.includes('linked_to') && (
                    <th>
                      <div className="table-header">
                        Linked To
                        <img
                          role="button"
                          src={sortBy !== "contact_id" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("contact_id");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="sort"
                        />
                      </div>
                    </th>
                  )}
                  {visibleColumns.includes('assigned_to') && (
                    <th>
                      <div className="table-header">
                        Assigned To
                        <img
                          role="button"
                          src={sortBy !== "user_id" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("user_id");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="sort"
                        />
                      </div>
                    </th>
                  )}
                  {visibleColumns.includes('priority') && (
                    <th>
                      <div className="table-header">
                        Priority
                        <img
                          role="button"
                          src={sortBy !== "priority" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("priority");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="sort"
                        />
                      </div>
                    </th>
                  )}

                  {activeTab === 1 && (
                    <th>
                      <div className="table-header">
                        Completed
                        <img
                          role="button"
                          src={sortBy !== "completed" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("completed");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="sort"
                        />
                      </div>
                    </th>
                  )}

                  {activeTab === 2 && (
                    <th>
                      <div className="table-header">
                        Archived
                        <img
                          role="button"
                          src={sortBy !== "archived" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("archived");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="sort"
                        />
                      </div>
                    </th>
                  )}

                  {visibleColumns.includes('due_date') && (
                    <th>
                      <div className="table-header">
                        Due Date
                        <img
                          role="button"
                          src={sortBy !== "due_date" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                          onClick={() => {
                            setSortBy("due_date");
                            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                          }}
                          alt="sort"
                        />
                      </div>
                    </th>
                  )}

                  {visibleColumns.includes('created_by') && (
                    <th>
                      <div className="table-header">Created By</div>
                    </th>
                  )}

                  {visibleColumns.includes('more') && (
                    <th>
                      <div className="table-header">More</div>
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {taskData.map((el) => (
                  <tr key={el.id} className="dark-H body-N">
                    {visibleColumns.includes('select') && (
                      <td>
                        <label className="container">
                          <input
                            type="checkbox"
                            checked={selectedItem.includes(el.id)}
                            onChange={() => handleSelectCheck(el.id)}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </td>
                    )}

                    {visibleColumns.includes('task_name') && (
                      <td className="head-5 flex items-center capitalize gap-2">
                        <Link to="#" onClick={(e) => { e.preventDefault(); handleTaskClick(el); }}>
                          {el.task_name}
                        </Link>
                      </td>
                    )}

                    {visibleColumns.includes('linked_to') && (
                      <td className="head-5 green-H">
                        {el.link_to_type ? (
                          <Link
                            to={`/${el.link_to_type}/${el.link_to_id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/${el.link_to_type}/${el.link_to_id}`);
                            }}
                            className="flex items-center gap-2 capitalize"
                          >
                            {el.link_to_name || "View Details"}
                          </Link>

                        ) : (
                          <span>N/A</span>
                        )}
                      </td>
                    )}

                    {visibleColumns.includes('assigned_to') && (
                      <td className="capitalize">
                        {el?.user?.first_name} {el?.user?.last_name}
                      </td>
                    )}

                    {visibleColumns.includes('priority') && (
                      <td className="dark-M body-S">
                        <div className="priority flex items-center gap-2 capitalize w-[6rem] h-[2rem]">
                          {el.priority === "high" ? (
                            <img src={high} alt="High" />
                          ) : el.priority === "medium" ? (
                            <img src={medium} alt="Medium" />
                          ) : el.priority === "low" ? (
                            <img src={low} alt="Low" />
                          ) : (
                            <img src={none} alt="None" />
                          )}
                          {el.priority}
                        </div>
                      </td>
                    )}

                    {visibleColumns.includes('due_date') && (
                      <td>
                        {moment(el.due_date).tz("America/New_York").format("MM/DD/YYYY")}
                        {activeTab === 0 && (
                          <span className={`due-date body-S ml-2 ${getDueDateInfo(el.due_date).className}`}>
                            {getDueDateInfo(el.due_date).label}
                          </span>
                        )}
                      </td>
                    )}

                    {visibleColumns.includes('created_by') && (
                      <td className="capitalize">
                        {el?.touch_plan?.name ||
                          `${el?.created_by?.first_name || ""} ${el?.created_by?.last_name || ""}`}
                      </td>
                    )}

                    {visibleColumns.includes('more') && (
                      <td className="flex gap-3 items-center">
                        {activeTab === 1 && <img src={Complete} alt="Completed" className="sidebar-icons" />}

                        {activeTab === 0 && (
                          <div className="flex gap-2">
                            <Check
                              className="dark-M"
                              size={20}
                              role="button"
                              onClick={() => {
                                setSelectedTask(el);
                                setSelectedId(el.id);
                                setShowCompleteTaskModal(true);
                              }}
                            />

                            <TaskActionMenu
                              options={todoMenuOption}
                              handleSelect={(item) => {
                                setSelectedTask(el);
                                if (item === "Edit") setShowEditTaskModal(true);
                                else if (item === "Reschedule") setShowResheduleTaskModal(true);
                                else setShowArchiveModal(true);
                              }}
                            />
                          </div>
                        )}

                        {activeTab === 2 && (
                          <TaskActionMenu
                            options={archiveMenuOption}
                            handleSelect={(item) => {
                              setSelectedTask(el);
                              if (item === "Delete") setShowDeleteModal(true);
                              else setShowUnarchiveModal(true);
                            }}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {taskData.length > 0 && (
          <TaskPagination
            activeTab={activeTab}
            selectedItem={selectedItem}
            paginationData={paginationData}
            handlePrev={handlePrev}
            handleNext={handleNext}
            handleUpdated={onSuccess}
            itemPerPage={itemPerPage}
            handleItemPerPageSelect={(value) => {
              setItemPerPage(value);
              setPageNumber(1);
            }}
          />
        )}
      </div>

      {/* Modals */}
      <AddtaskModal showModal={showCtaskModal} onClose={() => setShowCtaskModal(false)} onSuccess={onSuccess} />
      <TaskDetailsModal showModal={showModal} onClose={() => setShowModal(false)} id={selectedTask?.id} onCallApiAgain={onSuccess} />
      <CompleteTaskModal showModal={showCompleteTaskModal} onClose={() => setShowCompleteTaskModal(false)} onTaskCompleted={onSuccess} taskData={selectedTask} />
      <EditTaskModal showModal={showEditTaskModal} onClose={() => setShowEditTaskModal(false)} taskInitialData={selectedTask} onTaskEdited={onSuccess} />
      <AddNoteModal showModal={showNotesModal} onClose={() => setShowNotesModal(false)} taskData={selectedTask} onSuccess={onSuccess} />
      <ArchiveConfirmationModal showModal={showArchiveModal} onClose={() => setShowArchiveModal(false)} handleAction={handleArchieve} />
      <UnarchiveConfirmationModal showModal={showUnarchiveModal} onClose={() => setShowUnarchiveModal(false)} handleAction={handleUnarchieve} />
      <DeleteConfirmationModal showModal={showDeleteModal} disable={disableDelete} onClose={() => setShowDeleteModal(false)} handleDelete={handleDelete} />
      <ResheduleTaskModal
        showModal={showResheduleTaskModal}
        handleResheduleTask={handleResheduleTask}
        onClose={() => setShowResheduleTaskModal(false)}
        onDateChange={setDate}
      />

      {/* Column Customizer Modal */}
      {showColumnModal && (
        <ColumnCustomizer
          allColumns={allColumns}
          visibleColumns={visibleColumns}
          setVisibleColumns={setVisibleColumns}
          storageKey="taskVisibleColumns"
          onClose={() => setShowColumnModal(false)}
        />
      )}
    </BaseLayout>
  );
};

export default Tasks;
